const sliders = async function () {
    // const logoCarousel = document.querySelectorAll('.logoCarousel') !== null;
    const blogGallery = document.querySelectorAll(".blog-gallery"),
        carouselSlider = document.querySelectorAll(".carousel-slides");
    
    // Execute code if You really need it
    if (blogGallery) {
        let SwiperLib = await import('swiper/bundle');
        let Swiper = SwiperLib.default;

        // if (logoCarousel) {
        //     document.querySelectorAll('.logoCarousel').forEach((carousel) => {
        //         const logoCarouselSwiper = new Swiper(carousel, {
        //             lazy: false,
        //             slidesPerView: 2,
        //             spaceBetween: 0,
        //             loop: false,
        //             simulateTouch: false,
        //             autoplay: {
        //                 delay: 5000,
        //             },
        //             speed: 1500,
        //             breakpoints: {
        //                 480: {
        //                     slidesPerView: 3,
        //                     spaceBetween: 30
        //                 },
        //                 640: {
        //                     slidesPerView: 4,
        //                     spaceBetween: 40
        //                 },
        //                 1440: {
        //                     slidesPerView: 4,
        //                     spaceBetween: 60
        //                 }
        //             }
        //         });
        //     });
        // }

        if (blogGallery) {
            document.querySelectorAll(".blog-gallery").forEach(section => {
                const blogGalleryPreviewSwiper = new Swiper(section.querySelector(".blog-gallery__slider__preview"), {
                    lazy: true,
                    // loop: true,
                    slidesPerView: 4.5,
                    spaceBetween: 12,
                    watchSlidesVisibility: true,
                    watchSlidesProgress: true,
                    freeMode: true,
                    // centerInsufficientSlides: true,
                    slideToClickedSlide: true,
                    navigation: {
                        nextEl: '.blog-gallery-slider__next',
                        prevEl: '.blog-gallery-slider__prev',
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 4.4,
                            spaceBetween: 14,
                        },
                    },
                })

                const blogGalleryMainSwiper = new Swiper(section.querySelector(".blog-gallery__slider__main"), {
                    lazy: true,
                    slidesPerView: 1,
                    loop: true,
                    // allowTouchMove: false,
                    // simulateTouch: false,
                    thumbs: {
                        swiper: blogGalleryPreviewSwiper
                    },
                    navigation: {
                        nextEl: '.blog-gallery__slider__main--next',
                        prevEl: '.blog-gallery__slider__main--prev',
                    },
                })

            })
        }

        if (carouselSlider) {
            document.querySelectorAll(".carousel-slides").forEach(carousel => {

                const carouselSliderMainSwiper = new Swiper(carousel, {
                    lazy: true,
                    loop: true,
                    speed: 1000,
                    autoplay: {
                        delay: 2000,
                    },
                    effect: 'fade',
                    // spaceBetween: 30,
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                    allowTouchMove: true,
                    simulateTouch: true,
                })

            })
        }
        
    }
}

export const init = sliders;